import React from "react";
import styles from "./LoadingCircl.module.css";
const LoadingCircl = () => {
  return (
    <div class={styles.loadingContain}>
      <div class={styles.loadingMain}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default LoadingCircl;
